import { ROUTE_PATHS_WITHOUT_GYMAHOLIC_HEADER } from 'modules/routes/constants/index.cjs'

/**
   * Checks whether the current matchPath should have the <Header>.
   * @param  {string}  matchPath
   * @returns {boolean}
   */
function hasGymaholicHeaderRouteUtil (matchPath) {
  return !ROUTE_PATHS_WITHOUT_GYMAHOLIC_HEADER.some(
    pathWithoutGymaholicHeader => {
      return matchPath === pathWithoutGymaholicHeader
    }
  )
}

export default hasGymaholicHeaderRouteUtil
